import React, { useState } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";
import { IoLogoLinkedin } from "react-icons/io5";
import { FaGithub } from "react-icons/fa6";

const logo = "/corona.png";
const avatar = "/avatar.png";

function HomePage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Componente del modelo 3D
  const Model = () => {
    const { scene } = useGLTF("./Models/Rack/scene.glb");
    return <primitive object={scene} scale={1.5} position={[0, -1.5, 0]} />;
  };

  return (
    <div className="flex flex-col h-screen bg-black">
      {/* Navbar */}
      <nav className="flex bg-black mx-auto items-center justify-between px-5 py-6 w-full z-20">
        <div>
          <img src={logo} alt="App Logo" width={39} height={39} />
        </div>

        <button
          className="sm:hidden text-white"
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            {isDrawerOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            )}
          </svg>
        </button>

        <ul
  role="menu"
  className={`transition-all ease-in-out duration-300 sm:flex flex-col sm:flex-row sm:items-center sm:gap-5 cursor-pointer absolute sm:static min-h-screen sm:min-h-0 sm:bg-transparent sm:shadow-none shadow-xl ${
    isDrawerOpen ? "left-0 top-0 w-full bg-black z-20" : "left-[-100%]"
  }`}
>
  {isDrawerOpen && (
    <button
      className="absolute top-4 right-4 text-white sm:hidden"
      onClick={() => setIsDrawerOpen(false)}
    >
      X
    </button>
  )}

  {/* Contenedor centrado en móvil */}
  <div className="h-full flex flex-col justify-center items-center sm:flex-row sm:justify-between sm:items-center">
    {/* Elementos del menú */}

    {/* Redes sociales y avatar */}
    <div className="flex justify-center gap-4 mt-4 sm:mt-0 sm:ml-auto">
      <a href="https://www.linkedin.com/in/davidas156/">
        <IoLogoLinkedin
          size={39}
          className="text-white hover:text-yellow-400 transition-transform transform hover:scale-110"
        />
      </a>
      <a href="https://github.com/davidas56">
        <FaGithub
          size={39}
          className="text-white hover:text-yellow-400 transition-transform transform hover:scale-110"
        />
      </a>
      <img
        src={avatar}
        alt="User Avatar"
        width={39}
        height={39}
        className="rounded-full border-2 border-transparent hover:border-yellow-400 transition-all duration-300"
      />
    </div>
  </div>
</ul>
      </nav>

      {/* Sección principal con modelo 3D y texto */}
      <div className="flex flex-1 w-full bg-black overflow-hidden">
        <div className="w-1/2 relative">
          <Canvas className="absolute inset-0">
            <ambientLight intensity={2} />
            <directionalLight position={[10, 10, 5]} intensity={5} />
            <Model />
            <OrbitControls autoRotate={true} enableZoom={false} enablePan={false} enableRotate={false} />
          </Canvas>
        </div>
        
        <div className="flex flex-col items-center justify-center w-1/2 text-center z-10 p-4">
          <h1 className="text-white text-3xl sm:text-4xl md:text-6xl font-bold leading-tight mb-4">
            Bienvenido a Mi Portafolio
          </h1>
          <p className="text-gray-400 text-lg sm:text-xl max-w-xl">
            ¡Explora mis proyectos y conoce más sobre mí!
          </p>
          <p className="text-gray-400 text-lg sm:text-xl max-w-xl">
            ↓
          </p>
        </div>
      </div>
    </div>
  );
}

export default HomePage;